import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getOverviewProjects } from '../../api/dashboard';
import { Project } from '../Project/projectSlice';

export const getOverviewProjectsAsync = createAsyncThunk(
  'dashboards/getOverviewProjects',
  getOverviewProjects
);

export interface ProjectWithManHour extends Omit<Project, 'users'> {
  sumPlanManHours: number;
  sumActualManHours: number;
  sumTotalManHours: number;
}

interface DashboardState {
  projects: { count: number; data: ProjectWithManHour[] };
}

const initialState: DashboardState = {
  projects: { count: 0, data: [] }
};

export default createSlice({
  name: 'dashboards',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOverviewProjectsAsync.fulfilled, (state, action) => {
      state.projects = action.payload;
    });
  }
});
